import { render, staticRenderFns } from "./Screensaver.vue?vue&type=template&id=25656e9e&scoped=true"
import script from "./Screensaver.vue?vue&type=script&lang=js"
export * from "./Screensaver.vue?vue&type=script&lang=js"
import style0 from "./Screensaver.vue?vue&type=style&index=0&id=25656e9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25656e9e",
  null
  
)

export default component.exports